import BeveledEdgeCornerSvg from './BeveledEdgeCornerSvg';

export default BeveledEdgeCornerSvg;
export { BeveledEdgeCornerSvg };
